import React from "react";
import { FaKeyboard } from "react-icons/fa";
import RubiksCube from "../RubiksCube";

const stats = [
  {
    icon: <RubiksCube />,
    value: "12.4s",
    label: "Cube PB",
  },
  {
    icon: <FaKeyboard />,
    value: "164",
    label: "Peak WPM",
  },
];

function Stats() {
  return (
    <div className="home-stats" aria-label="Personal records">
      <p className="site-sidebar-section-label">Records</p>
      <ul className="stat-list">
        {stats.map((stat) => (
          <li className="stat-line" key={stat.label}>
            <span className="stat-icon" aria-hidden="true">
              {stat.icon}
            </span>
            <span className="stat-value">{stat.value}</span>
            <span className="stat-label">{stat.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Stats;
